import { Box, styled, Typography } from '@mui/material';
import { EmploymentType } from '@types';
import { useFormContext } from 'react-hook-form';
import { FormCheckbox } from 'redesign';

type EmploymentTypeCheckboxesFilterFormContext = {
  isFreelancer: boolean;
  isTempWorker: boolean;
  isEmployee: boolean;
};

export const EmploymentTypeCheckboxesFilter = ({
  allowedEmploymentTypes,
}: {
  allowedEmploymentTypes: EmploymentType[];
}) => {
  const form = useFormContext<EmploymentTypeCheckboxesFilterFormContext>();

  const filters = [
    {
      name: 'isFreelancer' as const,
      label: 'Zelfstandige',
      employmentType: EmploymentType.FREELANCER,
    },
    {
      name: 'isTempWorker' as const,
      label: 'Uitzendkracht',
      employmentType: EmploymentType.TEMPWORKER,
    },
    {
      name: 'isEmployee' as const,
      label: 'Werknemer',
      employmentType: EmploymentType.EMPLOYEE,
    },
  ];

  return (
    <Box>
      <Box>
        <Typography variant="body1">Dienstverband</Typography>
        <StyledHelperText hasError={form.formState.errors.isFreelancer?.message !== undefined}>
          Selecteer er minstens een
        </StyledHelperText>
      </Box>
      <Box>
        {filters.map((item) => (
          <FormCheckbox
            label={item.label}
            key={item.name}
            name={item.name}
            onChange={(val) => {
              if (val) {
                form.clearErrors('isFreelancer');
              }
            }}
            control={form.control}
            disabled={!allowedEmploymentTypes.includes(item.employmentType)}
          />
        ))}
      </Box>
    </Box>
  );
};

const StyledHelperText = styled(Box)<{ hasError: boolean }>(({ theme, hasError }) => ({
  textDecorationLine: hasError ? 'underline' : 'none',
  color: hasError ? theme.palette.lwDanger[100] : 'inherit',
  fontSize: '12px',
}));
